import { useSidebar } from "../../context/SidebarOpenContext";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa";
import Modal from "react-modal";
import ReusableDataTable from "../../hooks/ReusableDataTable";

function SectionActivities() {
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const fetchActivities = async () => {
    try {
      const res = await axios.get("sec_act/activities");
      setActivities(res.data);
    } catch (err) {
      console.error("Failed to fetch activity logs:", err);
    } finally {
      setLoading(false);
    }
  };
  const deleteActivity = async (id) => {
    if (!window.confirm("Are you sure to delete this activity?")) return;
    try {
      await axios.delete(`sec_act/activity/${id}`);
      setActivities(activities.filter((act) => act.id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
    }
  };

  const bulkDelete = async () => {
    if (!fromDate || !toDate) return alert("Please provide both dates.");
    try {
      await axios.post("sec_act/delete-by-date", { fromDate, toDate });
      setModalIsOpen(false);
      fetchActivities(); // Refresh
    } catch (err) {
      console.error("Bulk delete failed:", err);
    }
  };

  useEffect(() => {
    fetchActivities();
  }, []);

  const filteredActivities = activities.filter((row) =>
    [row.order_no, row.section, row.action]
      .some((field) => field?.toLowerCase().includes(searchTerm.toLowerCase()))
  );
  const columns = [
    {
      name: "Date & Time",width:"160px",
      selector: (row) => {
        const date = new Date(row.timestamp);
        return date.toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
      sortable: true,
    },
    { name: "Staff", selector: (row) => row.staff_name || "-", sortable: true },
    { name: "Order No", selector: (row) => row.order_no || "-", sortable: true },
    { name: "Colour", selector: (row) => row.colour_name || "-", sortable: true },
    { name: "Section", selector: (row) => row.section, sortable: true },
    // { name: "Section Log ID", selector: (row) => row.section_log_id, sortable: true },

    // { name: "Row Data", selector: (row) => JSON.stringify(row.section_row), wrap: true },
    { name: "Action", selector: (row) => row.action, sortable: true },
    {
      name: "Delete",
      width:"80px",
      cell: (row) => (
        <button onClick={() => deleteActivity(row.id)} className="text-red-600 hover:text-red-800">
          <FaTrash />
        </button>
      ),
    },
  ];
  return (
    <>
      <div className={` ${isSidebarOpen ? "p-4 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
        <div className="p-4 rounded-lg dark:border-gray-700  ">
          <div className="p-4 rounded-lg shadow bg-white">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Section Activities</h2>
              <button
                className="bg-red-600 text-white px-4 py-1 rounded hover:bg-red-700"
                onClick={() => setModalIsOpen(true)}
              >
                Delete by Date
              </button>
            </div>

            <ReusableDataTable
              columns={columns}
              data={filteredActivities}
              progressPending={loading}
              pagination
              highlightOnHover
              dense
            />
          </div>
        </div>
        {/* Modal for bulk delete */}
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={() => setModalIsOpen(false)}
          className="bg-white p-6 rounded shadow-md max-w-md mx-auto mt-32"
          overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center"
        >
          <h2 className="text-lg font-semibold mb-4">Delete Activities By Date</h2>
          <label className="block mb-2">
            From Date:
            <input
              type="date"
              className="border p-2 w-full rounded-md"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </label>
          <label className="block mb-4">
            To Date:
            <input
              type="date"
              className="border p-2 w-full rounded-md"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </label>
          <div className="flex justify-end space-x-4">
            <button className="bg-gray-400 text-white px-4 py-2 rounded" onClick={() => setModalIsOpen(false)}>Cancel</button>
            <button className="bg-red-600 text-white px-4 py-2 rounded" onClick={bulkDelete}>Delete</button>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default SectionActivities;